import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-trash-icon',
  templateUrl: 'trash-icon.component.html'
})
export class TrashIconComponent {
  constructor() {}
}
